module.exports = __webpack_public_path__ + "img/constellations.003b8c4b.png";